import React, { useEffect } from "react";

import { gsap } from "gsap";

const KickStart = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    gradient: {
      background: "#fbb304",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  useEffect(() => {
    gsap.fromTo(
      ".section",
      {
        autoAlpha: 0,
        y: 100,
      },
      {
        autoAlpha: 1,
        y: 0,
        ease: "expo.inOut",
        duration: 1,
        stagger: 0.1,
      }
    );
  });

  return (
    <div className="w-full h-full text-white " style={styles.blackbg}>
      <div className="w-full max-w-2xl m-auto py-8 px-4">
        <div className="text-xl section" style={styles.blueText}>
          AIESEC in SLIIT
        </div>
        <div className="text-4xl font-bold section">
          <div className="p-4 rounded-lg" style={styles.gradient}>
            KickStart22
          </div>
          <div className="text-2xl">
            Entrepreneurship & Startup Workshop Project
          </div>
        </div>

        <div className="text-xl mt-1 text-gray-400 section">
          Application Package
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Event Introduction</div>
          <p className="text-gray-400">
            <span className="rounded-md" style={styles.gradient}>
              &nbsp;KickStart&nbsp;
            </span>{" "}
            is an event initiated with the aim of supporting the young minds who
            wish to or have already started their own startup business. The main
            purpose of the event would be to give out all the crucial details,
            skills and techniques one might need to start their own business.
          </p>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Timeline</div>
          <div>
            <span className="font-bold">Application Open - </span>{" "}
            <span className="text-gray-300">5th of February 2022</span> <br />
            <span className="font-bold">Application Deadline - </span>{" "}
            <span className="text-gray-300">12th of February 2022</span> <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Team Structure</div>
          <div>
            <span className="">OCP x1</span> <br />
            <span className="">OCVP ER x3</span> <br />
            <span className="">OCVP PR x2</span> <br />
            <span className="">OCVP MKT x2</span> <br />
            <span className="">OCVP Events x1</span> <br />
            <span className="">OCVP Finance x1</span> <br />
            <span className="">OCVP Logistics x1</span> <br />
            <span className="">OCVP Delegates x2</span> <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Available Roles</div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #FFC845" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#FFC845" }}
            >
              OCP <span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Lead the entire OC to a financially and logistically
                  successful event.
                </li>
                <li>
                  Ensure the event is meeting its goals agreed upon between the
                  OC and the EB of AIESEC in SLIIT.
                </li>
                <li>
                  Ensure correct communication and reporting with OC,PM & the
                  EB.
                </li>
                <li>
                  Set and assure the respect of a specific timeline and an
                  action plan.
                </li>
                <li>Manage the OC and maintain good communication.</li>
                <li>Setting out initial timelines for all the OCVPs.</li>
                <li>Plan & track OC tasks and OC performance.</li>
                <li>Setting out ER raising plan together with OEVP PD.</li>
                <li>
                  Plan initial marketing ad PR campaigns together with OEVP
                  Marketing.
                </li>
                <li>
                  Always keep in touch with the PM & OEVP Finance regarding the
                  status of the ER raised.
                </li>
                <li>
                  Make sure that the marketing materials are ready & the
                  calendar is booked the day before it is supposed to be posted.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Strong Communication.</li>
                <li>Time management .</li>
                <li>Solution oriented .</li>
                <li>Experience in event management and coordination.</li>
                <li>Team and time management skills .</li>
                <li>Creativity and Innovative thinking .</li>
                <li>Attentive to details</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Overall success of the event.</li>
                <li>The impact of the event.</li>
                <li>Delegate engagement.</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #0373f3" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#0373f3" }}
            >
              OCVP Delegates <span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Being the first touchpoint between KickStart’22 delegates and
                  AIESEC in SLIIT.
                </li>
                <li>
                  Setting up expectation setting and internal briefing about the
                  requirements.
                </li>
                <li>Answering all the inquiries from the participants.</li>
                <li>Creating and managing a database of the participants.</li>
                <li>Creating needed communication channels.</li>
                <li>Managing invitations of participants.</li>
                <li>Managing the registrations of the participants.</li>
                <li>Participant interaction.</li>
                <li>
                  Pre, during, post event delegate/participant engagement.
                </li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in event management and coordination.</li>
                <li>Team and time management skills.</li>
                <li>Creativity and Innovative thinking.</li>
                <li>Excellent communication skills.</li>
                <li>Attentive to details.</li>
                <li>Solution oriented.</li>
                <li>Creative approach and idea generator.</li>
                <li>Event management skills.</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Time management for deadlines.</li>
                <li># of Delegates.</li>
                <li>Delegate engagement.</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #F85A40" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#F85A40" }}
            >
              OCVP Marketing <span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Planning event marketing timeline.</li>
                <li>Creating and implementing marketing strategies</li>
                <li>Increasing virtual outreach through various platforms.</li>
                <li>Creating digital marketing materials & tools.</li>
                <li>Collect content for showcasing.</li>
                <li>Content creation.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Content Management.</li>
                <li>Creative thinking & Time management.</li>
                <li>Solution oriented.</li>
                <li>
                  Knowledge in branding, graphic designing & Virtual
                  Storytelling.
                </li>
                <li>Experience in planning and running marketing campaigns.</li>
                <li>
                  Experience on designing promotional material for an event.
                </li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>0 issues in screen controlling during the event.</li>
                <li>good delegates involvement in the online campaign.</li>
                <li>Impact showcased through Digital Platforms.</li>
                <li>0 Branding complains.</li>
                <li>0 content complaint .</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #FFC845" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#FFC845" }}
            >
              OCVP External Relations <span className="text-gray-500"> x3</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Conduct market researches on potential partners together with
                  OEVP PD.
                </li>
                <li>Approach potential companies for partnerships.</li>
                <li>Follow-ups and partnership delivery.</li>
                <li>
                  Market research experience of partnership management with a
                  variety of stakeholders.
                </li>
                <li>
                  Develop partnerships with organizations in order to get
                  monetary or in kind support, Online, print & digital media
                  partnerships.
                </li>
                <li>
                  Update the OEVP PD, OCP & PM regarding leads & confirmed
                  partnerships.
                </li>
                <li>Creating and implementing ER strategies.</li>
                <li>Responsible for the partnership deliverables.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Strong Communication.</li>
                <li>Stakeholder management.</li>
                <li>Time management.</li>
                <li>Documentationing.</li>
                <li>Solution oriented.</li>
                <li>Partnership Management.</li>
                <li>Experience on event management and sales.</li>
                <li>
                  Experience in planning and running PR and marketing campaigns
                  for events.
                </li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li># of ER partners.</li>
                <li>Overall successful event.</li>
                <li>% of ER raise out of cost.</li>
                <li># of company meetings arrange.</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #0CB9C1" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#0CB9C1" }}
            >
              OCVP Finance<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Preparing event budget.</li>
                <li>
                  Collecting and documentation of all the supporting documents.
                </li>
                <li>Preparing the event report.</li>
                <li>Expenses an partnership tracking.</li>
                <li>Ensure partnership delivery.</li>
                <li>Manage the finance of the event.</li>
                <li>Cash Flow management of the event.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in budget preparation.</li>
                <li>Experience in budgetary control.</li>
                <li>Information & data management skills.</li>
                <li>Reporting skills.</li>
                <li>Flexibility & adaptability.</li>
                <li>Critical thinking.</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li> % of budget achievement.</li>
                <li> 0 Cash flow issues.</li>
                <li>Profitability of the event.</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #0373f3" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#0373f3" }}
            >
              OCVP Events<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Delivering the model of the event.</li>
                <li>Responsible for the smooth flow of the event.</li>
                <li>Pre, During, post event Delegate Engagement.</li>
                <li>
                  Research to improve the online & physical delegate experience
                  and engagement.
                </li>
                <li>Agenda Management.</li>
                <li>
                  Maintain the drive folder with daily info and materials of
                  whole OC.
                </li>
                <li>
                  Performing additional duties related to the Project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in event planning and management.</li>
                <li>
                  Experience in attention to detail and working under pressure.
                </li>
                <li>Strategic planning ability.</li>
                <li>Ability to manage stress and work under pressure.</li>
                <li>Excellent time management skills & solution oriented.</li>
                <li>Ideas generator, creative approach.</li>
                <li>Excellent communication skills.</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Time management for deadlines.</li>
                <li># of Delegates.</li>
                <li>Smooth flow of the events in the agenda.</li>
                <li>Feedbacks from delegates.</li>
                <li>good delegates involvement.</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #F85A40" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#F85A40" }}
            >
              OCVP Public Relations<span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Ensuring all systems are in place for guests.</li>
                <li>
                  Securing guest speakers and ensuring their objectives are
                  achieved.
                </li>
                <li>Managing the experience of the guests.</li>
                <li>Develop partnerships with stakeholders & NGOs.</li>
                <li>Creating and implementing PR strategies.</li>
                <li>
                  Identify potential entrepreneurial clubs and getting onboard.
                </li>
                <li>Online, print & digital media partnerships.</li>
                <li>Responsible for the contents published on media.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Professional communication skills.</li>
                <li>Public figures handling.</li>
                <li>Partnership Management.</li>
                <li>Solution oriented & Critical thinking.</li>
                <li>Presentation skills & Networking skills.</li>
                <li>Flexibility & adaptability.</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li># of new PR partnerships.</li>
                <li>Online, Print & Digital Media reach.</li>
                <li>Partners satisfaction.</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #0CB9C1" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#0CB9C1" }}
            >
              OCVP Logistics<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Coordinate with venue management to facilitate the event.
                </li>
                <li>Work with ER team for sales.</li>
                <li>Identifying logistical requirements.</li>
                <li>
                  Finding most appropriate ways to fulfill logistics
                  requirements.
                </li>
                <li>Stakeholder management when necessary.</li>
                <li>
                  Preparing inventory management and inventory flow management
                  plans.
                </li>
                <li>
                  Finding partners to cover logistical requirements together
                  with OCVP ER.
                </li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Skills & Knowledge</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Solution oriented.</li>
                <li>Flexibility & adaptability.</li>
                <li>Strong Communication.</li>
                <li>Critical thinking.</li>
                <li>Time management.</li>
                <li>Experience in event management.</li>
                <li>Experience in corporate sales negotiation.</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPI / MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>0 logistics complaints.</li>
                <li># partner aligned/raised to cover.</li>
                <li>logistics requirements.</li>
              </ul>
            </div>
          </div>
          {/** Contact Info ***/}
          <div className="mt-8">
            <div className="w-full h-1 bg-gray-700 mb-8"></div>
            <div className="text-2xl mb-4 font-semibold">Contact Info</div>
            <div>
              <div>For any clarifications, </div>
              <div style={styles.blueText} className="text-3xl">
                Chethali Eliyapura
              </div>
              <div className="text-gray-400">
                OEVP oGX B2C – AIESEC in SLIIT
              </div>
              <div className="text-gray-400">
                chethali.eliyapura4@aiesec.net
              </div>
              <div className="text-gray-400">+94 76 636 8079</div>
            </div>
          </div>
          <a
            href="https://forms.gle/XPS1ygCGLHpW22Gd6"
            target="_blank"
            rel="noreferrer"
          >
            <div
              className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer"
              style={{ background: "#037ef3" }}
            >
              Apply
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default KickStart;
